export default "__VITE_ASSET__3BQXpIv3__"